var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OvertimeRequestList',{attrs:{"activeTabIndex":2,"title":"Rejected","extraRouteQuery":"approved=false"}})
}
var staticRenderFns = []

export { render, staticRenderFns }